import React from 'react'
import MasonryGalleryContainer from '../../../../Components/Miscellaneous/Gallery/MasonryGallery'

export default function MasonryGallery() {
  return (
    <div className='page-body'>
        <MasonryGalleryContainer/>
    </div>
  )
}
